module.exports = __webpack_public_path__ + "img/VehicleInsurance.6086a41a.webp";